import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Link } from "react-router-dom";
import { MEDIA, SPECTORA_URL } from "@/lib/media";

export default function CinematicBand() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.2, 1]);

  return (
    <section ref={ref} className="relative h-[70vh] md:h-[90vh] overflow-hidden" data-testid="cinematic-band">
      <motion.div style={{ scale }} className="absolute inset-0">
        <video className="absolute inset-0 w-full h-full object-cover" autoPlay muted loop playsInline poster={MEDIA.extAlt}>
          <source src={MEDIA.bandVideo} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-ink/40" />
      </motion.div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display uppercase text-cream leading-[0.9] tracking-tight text-5xl md:text-8xl max-w-4xl"
        >
          Certainty Is <span className="text-gold">Priceless</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-cream/70 mt-6 max-w-xl text-lg leading-relaxed"
        >
          Before you close on your next home, let Home Point Inspection, Inc. confirm exactly what
          you're investing in — down to the last detail.
        </motion.p>
        <a
          href={SPECTORA_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-10 inline-flex border border-gold text-gold hover:bg-gold hover:text-ink transition-colors duration-300 px-10 py-4 font-display uppercase tracking-[0.15em] text-sm"
          data-testid="band-cta-button"
        >
          Schedule Your Inspection
        </a>
      </div>
    </section>
  );
}
